import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { BWIcons, Icons } from '@honeycomb-npm/honeycomb';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { IconCSS } from './IconCSS.js';
import { IconFont } from './IconFont.js';
import { IconSVGFile } from './IconSVGFile.js';
import { IconSVGInline } from './IconSVGInline.js';

var _excluded = ["children", "className", "iconClassName", "isInline", "isRHS", "screenreader", "symbol", "svgArgs", "theme", "type"];
var Icon = props => {
  var {
      children,
      className = '',
      iconClassName,
      isInline,
      isRHS,
      screenreader,
      symbol,
      svgArgs,
      theme,
      type
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  var iconname = symbol;
  var isBankwest = theme && theme.toLowerCase() === 'bankwest';
  var iconlist = isBankwest ? BWIcons.IconList : Icons.IconList;
  if (typeof iconlist[symbol] === 'undefined') {
    var regex = new RegExp("^".concat(symbol, "(.(?!.Args$))+$"));
    var similarIcons = Object.keys(iconlist).filter(candidateIconname => regex.test(candidateIconname));
    if (similarIcons.length > 0) {
      iconname = similarIcons[0]; // eslint-disable-line prefer-destructuring
    } else {
      return null;
    }
  }

  // Add wrapper classnames
  var wrapperClassName = classNames('icon-wrapper', className !== null && className !== void 0 ? className : className, {
    'icon-inline': isInline,
    'icon-sm': iconname.indexOf('16') > -1
  });

  // adding icon className
  var iconClassNames = classNames(iconClassName !== null && iconClassName !== void 0 ? iconClassName : iconClassName, {
    'ml-1': isRHS
  });
  var textClassNames = classNames({
    'ml-1': !isRHS
  });
  var image = null;
  switch (type) {
    case 'svgfile':
      image = /*#__PURE__*/React.createElement(IconSVGFile, {
        symbol: iconname,
        className: iconClassNames,
        theme: theme
      });
      break;
    case 'svginline':
      image = /*#__PURE__*/React.createElement(IconSVGInline, {
        symbol: iconname,
        className: iconClassNames,
        args: svgArgs,
        theme: theme
      });
      break;
    case 'css':
      image = /*#__PURE__*/React.createElement(IconCSS, {
        symbol: iconname,
        className: iconClassNames,
        theme: theme
      });
      break;
    case 'iconfont':
      image = /*#__PURE__*/React.createElement(IconFont, {
        symbol: iconname,
        className: iconClassNames
      });
      break;
  }
  var hcid = "".concat(Icon.name.toLocaleLowerCase(), "-").concat("10.6.2");

  // Create an child element for the icon wrapper
  var component = /*#__PURE__*/React.createElement(React.Fragment, null, !isRHS && image, children && /*#__PURE__*/React.createElement("span", {
    className: textClassNames
  }, children), screenreader && /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, screenreader), isRHS && image);
  if (props.href) {
    return /*#__PURE__*/React.createElement("a", _extends({
      className: wrapperClassName
    }, attributes, {
      "data-hcid": hcid
    }), component);
  }
  if (typeof props.onClick !== 'undefined') {
    return /*#__PURE__*/React.createElement("button", _extends({
      className: wrapperClassName,
      type: "button"
    }, attributes, {
      "data-hcid": hcid
    }), component);
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    className: wrapperClassName
  }, attributes, {
    "data-hcid": hcid
  }), component);
};
/* eslint-disable react/default-props-match-prop-types */
Icon.defaultProps = {
  className: '',
  iconClassName: '',
  screenreader: '',
  symbol: 'controlSearch24',
  type: 'svgfile'
};
Icon.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // eslint-disable-next-line 
  className: props => {
    if (typeof props.className !== 'string') {
      return new Error('The icon classname should be a string');
    }
    if (props.className && props.className.indexOf('icon-wrapper') !== -1) {
      return new Error('The icon classname cannot include "icon-wrapper"');
    }
  },
  href: PropTypes.string,
  // eslint-disable-next-line 
  iconClassName: props => {
    if (typeof props.iconClassName !== 'string') {
      return new Error('The icon iconClassName should be a string');
    }
    if (props.iconClassName && props.iconClassName.indexOf('hc-icon') !== -1) {
      return new Error('The icon iconClassName cannot include "hc-icon"');
    }
    if (props.href && props.onClick) {
      return new Error('The icon should not contain both a "href" and an "onClick" prop.');
    }
  },
  isInline: PropTypes.bool,
  isRHS: PropTypes.bool,
  onClick: PropTypes.func,
  screenreader: PropTypes.string,
  svgArgs: PropTypes.object,
  symbol: PropTypes.oneOf(Object.keys(_objectSpread2(_objectSpread2({}, Icons.IconList), BWIcons.IconList)).filter(iconname => {
    if (iconname.match(/Args$/)) {
      return false;
    }
    return true;
  })),
  theme: PropTypes.string
};

export { Icon };
